import { NextSeo } from 'next-seo';

import { ReactElement, useEffect } from 'react';

import { css } from '@emotion/react';

import usePortal from '@lib/hook/usePortal';
import useRouterHook from '@lib/hook/useRouterHook';

import FraudHead from '@components/web/Fraud/FraudHead/FraudHead';
import FraudSearchForm from '@components/web/Fraud/FraudSearchForm/FraudSearchForm';
import BasicLayout from '@components/web/Layout/BaisicLayout';

export default function Fraud(): ReactElement {
  const { router } = useRouterHook();

  return (
    <BasicLayout
      headerOptions={{
        isShowBackground: true,
        types: [{ type: 'primary' }, { type: 'navigation' }],
      }}
    >
      <NextSeo
        title="중고나라 사기 통합 조회"
        description="판매자의 휴대폰, 계좌번호, 메신저 ID, 이메일로 피해 사례 조회를 이용해 보세요!"
        canonical={`${process.env.NEXT_PUBLIC_DEFAULT_URL}${router.asPath}`}
        openGraph={{
          type: 'website',
          locale: 'ko_KR',
          url: `${process.env.NEXT_PUBLIC_DEFAULT_URL}${router.asPath}`,
          site_name: '중고나라',
          title: '중고나라 사기 통합 조회',
          description:
            '판매자의 휴대폰, 계좌번호, 메신저 ID, 이메일로 피해 사례 조회를 이용해 보세요!',
        }}
      />
      <div css={container}>
        <FraudHead />
        <FraudSearchForm />
      </div>
    </BasicLayout>
  );
}

const container = css`
  max-width: 1200px;
  min-height: 100%;
  margin: 0 auto;
`;
